import { useMediaQuery } from '@mui/material';

export const useBwBreakpoints = () => {
  const is640 = useMediaQuery('(max-width:640px)');
  const is1100 = useMediaQuery('(max-width:1100px)');

  return [is640, is1100] as const;
};
